import {Component, inject} from '@angular/core';
import {ContactSectionComponent} from "../../../homepage/components/contact-section/contact-section.component";
import {LoanSliderComponent} from "../../../loan/components/loan-slider/loan-slider.component";
import {StaticPageService} from "../../services/static-page.service";
import {StaticPage} from "../../models/static-page";
import {ActivatedRoute} from "@angular/router";
import {Subscription} from "rxjs";
import {EasyFinancePaymentAccount} from "../../models/easy-finance-payment-account";
import {DiscountBox} from "../../models/discount-box";
import {PageBase} from "../../../core/components/page-base";
import {getTranslation} from "../../../core/models/translatable-model-abstract";

@Component({
  selector: 'app-static-page-single',
  standalone: true,
  imports: [
    ContactSectionComponent,
    LoanSliderComponent
  ],
  templateUrl: './static-page-single.component.html',
  styleUrl: './static-page-single.component.scss'
})
export class StaticPageSingleComponent extends PageBase {
  private staticPageService = inject(StaticPageService);
  private activatedRoute = inject(ActivatedRoute);

  protected staticPage: StaticPage | null = null;

  protected slug: string = "";
  protected easyFinancePaymentAccounts: EasyFinancePaymentAccount[] = [];
  protected discountBoxes: DiscountBox[] = [];

  protected activatedRouteSubscription: Subscription = new Subscription();

  protected getEasyfinancePaymentAccounts(): void {
    this.staticPageService.getEasyfinancePaymentAccountsFromApi().subscribe({
      next: easyFinancePaymentAccountsRes => {
        this.easyFinancePaymentAccounts = easyFinancePaymentAccountsRes;
      },
    });
  }

  protected getDiscountBoxes(): void {
    this.staticPageService.getDiscountBoxesFromApi().subscribe({
      next: discountBoxesRes => {
        this.discountBoxes = discountBoxesRes;
      },
    });
  }

  override ngOnInit(): void {
    this.activatedRouteSubscription = this.activatedRoute.params.subscribe(params => {
      this.slug = params['slug'] ?? this.activatedRoute.snapshot.data["slug"];
      this.staticPageService.getBySlugFromApi(this.slug).subscribe({
          next: staticPageModel => {
            this.staticPage = staticPageModel;
            if (staticPageModel.constant == "HOW_TO_PAY_OFF") {
              this.getEasyfinancePaymentAccounts();
            }
            if (staticPageModel.constant == "DISCOUNTS") {
              this.getDiscountBoxes();
            }

            this.pageTitle = getTranslation(this.staticPage)?.seoTitle;
            this.metaDescription = getTranslation(this.staticPage)?.seoDescription;
            super.ngOnInit();
          },
        }
      );
    });
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.activatedRouteSubscription.unsubscribe();
  }

  protected readonly getTranslation = getTranslation;
}
